export function removeParams(path: string): string {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const pathWithoutQuery = path.split('?')[0];
  const paths = pathWithoutQuery.split('/');
  const pathsWithoutParams = [...paths];

  for (const p of paths) {
    if (!isNaN(parseInt(p, 10)) || uuidRegex.test(p)) {
      // checks if path partial is UUID or integer and assume that it's an param then
      pathsWithoutParams.pop();
    }
  }

  return pathsWithoutParams.join('/');
}
